/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.query.understanding.mkpl.autocomp.rpc.MarketplaceAutocompleteRpc
 */

export const autocompleteRpc = {
  serviceName: 'com.hubspot.query.understanding.mkpl.autocomp.rpc.MarketplaceAutocompleteRpc',
  rpcName: 'autocomplete',
  auth: 'app',
  fingerprint: 'FkqeuHqs_QVD_45rnDQObuS0OyEDABBF',
  na1Only: false
};